import Setor from "model/administracao/cadastro/Setor";
import { BaseModel } from "model/BaseModel";
import ClassePlanoAuditoria from "./ClassePlanoAuditoria";

export default class PlanoAuditoria implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    ativo: boolean;
    classes: ClassePlanoAuditoria[];

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        ativo = true,
        classes = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.ativo = ativo;
        this.classes = classes;
    }
}
